/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CriteriaSubMenu } from '../../models/criteria-sub-menu';
import { SubMenu } from '../../models/sub-menu';

export interface ApiMasterSubMenuGetByCriteriaPost$Params {
      body?: CriteriaSubMenu
}

export function apiMasterSubMenuGetByCriteriaPost(http: HttpClient, rootUrl: string, params?: ApiMasterSubMenuGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubMenu>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterSubMenuGetByCriteriaPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SubMenu>>;
    })
  );
}

apiMasterSubMenuGetByCriteriaPost.PATH = '/api/Master/SubMenu/GetByCriteria';
